exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-border th[data-v-47960155]{padding:12px 6px}.many-field-tr td[data-v-47960155]{padding:6px}.lp-form-type[data-v-47960155]{color:#787878;display:table-cell;font-size:.8rem}.table-cell[data-v-47960155]{text-align:left;width:100%}.est-title[data-v-47960155]{padding-bottom:12px}.est-content[data-v-47960155]{font-size:.9rem}.btn-confirm[data-v-47960155],.btn-process[data-v-47960155],.btn-success[data-v-47960155]{color:#fff}.btn-confirm[data-v-47960155]{background-color:#ffc107}.btn-process[data-v-47960155]{background-color:#4dbd74}.btn-success[data-v-47960155]{background-color:#fd7014}", ""]);

// exports
